import React from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button'; // Importando o botão genérico
import './MessageModal.css';

function MessageModal({ isOpen, onClose, onConfirm, title, message }) {
  if (!isOpen) return null;

  return (
    <div className="message-modal-overlay">
      <div className="message-modal">
        <h2>{title}</h2>
        <p>{message}</p>
        <div className="message-modal-buttons">
          {/* Substituindo o botão de "Cancelar" pelo botão genérico */}
          <Button
            type="cancelar"
            label="Cancelar"
            onClick={onClose}
            className=""
          />
          {/* Substituindo o botão de "Confirmar" pelo botão genérico */}
          <Button
            type="confirmar"
            label="Confirmar"
            onClick={onConfirm}
            className=""
          />
        </div>
      </div>
    </div>
  );
}

// Definindo propTypes para validação
MessageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default MessageModal;
